function hasLength(val) {
  return val.length > 0
}

function isArray(val) {
  return Array.isArray(val)
}

function isArrayFull(val) {
  return isArray(val) && hasLength(val)
}

module.exports = {
  hasLength: hasLength,
  isArray: isArray,
  isArrayFull: isArrayFull
}